/**
 * API client do app `cotacoes/` (ADR-0052 — CotacaoTerceiro).
 *
 * Endpoints (sem trailing slash, padrao do projeto):
 *   GET    /api/cotacoes?orcamento=&tipo=&situacao=   (orcamento:view)
 *   POST   /api/cotacoes                              (orcamento:edit)
 *   GET    /api/cotacoes/{id}                         (orcamento:view)
 *   PATCH  /api/cotacoes/{id}                         (orcamento:edit)
 *   DELETE /api/cotacoes/{id}                         (orcamento:edit; so ESTIMADA)
 *   POST   /api/cotacoes/{id}/tornar-firme            (cotacao:aprovar)
 *
 * Situacoes persistidas (Q1): apenas ESTIMADA e FIRME. "Vencida" e derivada
 * (`vencida` bool no payload) — nunca um estado.
 */

const PREFIXO = "/api/cotacoes";

// Espelha cotacoes.models.TIPOS_COTACAO (CATEGORIAS_PARCEIRO + acrescimos).
// Labels com acento sao de exibicao; o valor enviado e o codigo do backend.
export const TIPOS_COTACAO = [
  { codigo: "LAQUEACAO", label: "Laqueação" },
  { codigo: "PINTURA", label: "Pintura" },
  { codigo: "VIDRARIA", label: "Vidraria" },
  { codigo: "METAIS", label: "Metais" },
  { codigo: "MARMORE", label: "Mármore" },
  { codigo: "SERRALHERIA", label: "Serralheria" },
  { codigo: "EMPREITA_MONTAGEM", label: "Empreita de montagem" },
  { codigo: "ICAMENTO", label: "Içamento" },
  { codigo: "FRETE", label: "Frete" },
  { codigo: "OUTROS", label: "Outros" },
];

// Fallback local dos fatores padrao por tipo (spec §0.11). A fonte da verdade
// e `ConfiguracaoComercial.fatores_terceiro_padrao` — quando a tela tiver a
// config carregada, ela vence; este mapa so cobre a ausencia dela.
export const FATOR_LUCRO_PADRAO_POR_TIPO = {
  LAQUEACAO: "2.000",
  PINTURA: "2.000",
  VIDRARIA: "2.000",
  METAIS: "2.000",
  MARMORE: "2.000",
  SERRALHERIA: "2.000",
  EMPREITA_MONTAGEM: "1.500",
  ICAMENTO: "1.200",
  FRETE: "1.200",
  OUTROS: "1.500",
};

// Tone da Pill por situacao (vencida ganha danger por cima, na tela).
export const SITUACAO_TONE_COTACAO = {
  ESTIMADA: "warning",
  FIRME: "success",
};

export const SITUACAO_LABEL_COTACAO = {
  ESTIMADA: "Estimada",
  FIRME: "Firme",
};

// ---------- CRUD ----------

export function listarCotacoes(request, { orcamento, tipo, situacao } = {}, options = {}) {
  const usp = new URLSearchParams();
  if (orcamento) usp.set("orcamento", orcamento);
  if (tipo) usp.set("tipo", tipo);
  if (situacao) usp.set("situacao", situacao);
  const qs = usp.toString();
  return request(`${PREFIXO}${qs ? `?${qs}` : ""}`, options);
}

export function obterCotacao(request, id, options = {}) {
  return request(`${PREFIXO}/${id}`, options);
}

export function criarCotacao(request, dados) {
  // dados: {orcamento, tipo, ambiente?, parceiro?, fornecedor_nome?,
  //         descricao_escopo?, valor_estimado, fator_lucro?, validade_ate?}
  return request(PREFIXO, {
    method: "POST",
    body: JSON.stringify(dados),
  });
}

export function atualizarCotacao(request, id, dados) {
  return request(`${PREFIXO}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}

// DELETE so e aceito em ESTIMADA (400 com `detalhe` nas demais).
export function excluirCotacao(request, id) {
  return request(`${PREFIXO}/${id}`, { method: "DELETE" });
}

// ---------- Tornar firme (cotacao:aprovar) ----------

/**
 * Tambem serve de "Renovar" numa FIRME vencida: reenvia valor + validade.
 * Aprovar uma segunda cotacao do mesmo (orcamento, tipo, ambiente) rebaixa
 * a anterior para ESTIMADA (auditado no backend).
 */
export function tornarCotacaoFirme(request, id, { valor_cotado, validade_ate }) {
  return request(`${PREFIXO}/${id}/tornar-firme`, {
    method: "POST",
    body: JSON.stringify({ valor_cotado, validade_ate }),
  });
}
